export default {
  namespaced: true,
  state: {
    currentDate: null,
    selectType: null,
    selectDay: null,

    reservation: {
      salonList: [],
      selectedSalonId: '',
      businessDayList: [],
      selectedBusinessDay: '',
      roomList: [],
      selectedRoomId: '',
      startList: [],
      selectedStartListHour: '',
      selectedStartListMinute: '',
      endList: [],
      selectedEndListHour: '',
      selectedEndListMinute: '',
    },
    seminarInfo: {
      organizerMemberId1: '',
      organizerMemberName1: '',
      organizerMemberTel1: '',
      organizerMemberId2: '',
      organizerMemberName2: '',
      organizerMemberTel2: '',
      organizerMemberId3: '',
      organizerMemberName3: '',
      organizerMemberTel3: '',
      title: '',
      seminarType: '',
      paid: false,
      courseFee: '',
      remark: '',
      hourFrom: '',
      minuteFrom: '',
      hourTo: '',
      minuteTo: '',
      instructorMemberId1: '',
      instructorMemberName1: '',
      instructorMemberId2: '',
      instructorMemberName2: '',
      instructorMemberId3: '',
      instructorMemberName3: '',
    },
    seminarTypeList: [],
  },
  getters: {
    currentDate: state => state.currentDate,
    selectType: state => state.selectType,
    selectDay: state => state.selectDay,

    RESERVATION_SALON_LIST: state => state.reservation.salonList,
    RESERVATION_SELECTED_SALON_ID: state => state.reservation.selectedSalonId,
    RESERVATION_BUSINESS_DAY_LIST: state => state.reservation.businessDayList,
    RESERVATION_SELECTED_BUSINESS_DAY: state => state.reservation.selectedBusinessDay,
    RESERVATION_ROOM_LIST: state => state.reservation.roomList,
    RESERVATION_SELECTED_ROOM_ID: state => state.reservation.selectedRoomId,
    RESERVATION_START_LIST: state => state.reservation.startList,
    RESERVATION_SELECTED_START_LIST_HOUR: state => state.reservation.selectedStartListHour,
    RESERVATION_SELECTED_START_LIST_MINUTE: state => state.reservation.selectedStartListMinute,
    RESERVATION_END_LIST: state => state.reservation.endList,
    RESERVATION_SELECTED_END_LIST_HOUR: state => state.reservation.selectedEndListHour,
    RESERVATION_SELECTED_END_LIST_MINUTE: state => state.reservation.selectedEndListMinute,

    SEMINAR_INFO: state => state.seminarInfo,
    SEMINAR_TYPE_LIST: state => state.seminarTypeList,

    API_RESERVATION_SALON_REQUEST_DATA: state => {
      return {
        salonId: state.reservation.selectedSalonId,
        roomId: state.reservation.selectedRoomId,
        reservationDate: state.reservation.selectedBusinessDay,
        hourFrom: state.reservation.selectedStartListHour,
        minuteFrom: state.reservation.selectedStartListMinute,
        hourTo: state.reservation.selectedEndListHour,
        minuteTo: state.reservation.selectedEndListMinute,
        seminarInfo: null,
      }
    }

  },
  mutations: {
    setCurrentDate(state, currentDate) {
      state.currentDate = currentDate;
    },
    setSelectType(state, selectType) {
      state.selectType = selectType;
    },
    setSelectDay(state, selectDay) {
      state.selectDay = selectDay;
    },

    RESERVATION_SET_SALON_LIST(state, salonList) {
      state.reservation.salonList = salonList;
    }
    ,
    RESERVATION_SET_SELECTED_SALON_ID(state, selectedSalonId) {
      state.reservation.selectedSalonId = selectedSalonId;
    },
    RESERVATION_SET_BUSINESS_DAY_LIST(state, businessDayList) {
      state.reservation.businessDayList = businessDayList;
    },
    RESERVATION_SET_SELECTED_BUSINESS_DAY(state, selectedBusinessDay) {
      state.reservation.selectedBusinessDay = selectedBusinessDay;
    },
    RESERVATION_SET_ROOM_LIST(state, roomList) {
      state.reservation.roomList = roomList;
    },
    RESERVATION_SET_SELECTED_ROOM_ID(state, selectedRoomId) {
      state.reservation.selectedRoomId = selectedRoomId;
    },
    RESERVATION_SET_START_LIST(state, startList) {
      state.reservation.startList = startList;
    },
    RESERVATION_SET_SELECTED_START_LIST_HOUR(state, selectedStartListHour) {
      state.reservation.selectedStartListHour = selectedStartListHour;
    },
    RESERVATION_SET_SELECTED_START_LIST_MINUTE(state, selectedStartListMinute) {
      state.reservation.selectedStartListMinute = selectedStartListMinute;
    },
    RESERVATION_SET_END_LIST(state, endList) {
      state.reservation.endList = endList;
    },
    RESERVATION_SET_SELECTED_END_LIST_HOUR(state, selectedEndListHour) {
      state.reservation.selectedEndListHour = selectedEndListHour;
    },
    RESERVATION_SET_SELECTED_END_LIST_MINUTE(state, selectedEndListMinute) {
      state.reservation.selectedEndListMinute = selectedEndListMinute;
    },

    SEMINAR_SET_INFO(state, seminarInfo) {
      state.seminarInfo = seminarInfo;
    },
    SEMINAR_SET_INFO_ORGANIZER_MEMBER_ID1(state, organizerMemberId1) {
      state.seminarInfo.organizerMemberId1 = organizerMemberId1;
    },
    SEMINAR_SET_INFO_ORGANIZER_MEMBER_NAME1(state, organizerMemberName1) {
      state.seminarInfo.organizerMemberName1 = organizerMemberName1;
    },
    SEMINAR_SET_INFO_ORGANIZER_MEMBER_TEL1(state, organizerMemberTel1) {
      state.seminarInfo.organizerMemberTel1 = organizerMemberTel1;
    },
    SEMINAR_SET_INFO_ORGANIZER_MEMBER_ID2(state, organizerMemberId2) {
      state.seminarInfo.organizerMemberId2 = organizerMemberId2;
    },
    SEMINAR_SET_INFO_ORGANIZER_MEMBER_NAME2(state, organizerMemberName2) {
      state.seminarInfo.organizerMemberName2 = organizerMemberName2;
    },
    SEMINAR_SET_INFO_ORGANIZER_MEMBER_TEL2(state, organizerMemberTel2) {
      state.seminarInfo.organizerMemberTel2 = organizerMemberTel2;
    },
    SEMINAR_SET_INFO_ORGANIZER_MEMBER_ID3(state, organizerMemberId3) {
      state.seminarInfo.organizerMemberId3 = organizerMemberId3;
    },
    SEMINAR_SET_INFO_ORGANIZER_MEMBER_NAME3(state, organizerMemberName3) {
      state.seminarInfo.organizerMemberName3 = organizerMemberName3;
    },
    SEMINAR_SET_INFO_ORGANIZER_MEMBER_TEL3(state, organizerMemberTel3) {
      state.seminarInfo.organizerMemberTel3 = organizerMemberTel3;
    },
    SEMINAR_SET_INFO_TITLE(state, title) {
      state.seminarInfo.title = title;
    },
    SEMINAR_SET_INFO_SEMINAR_TYPE(state, seminarType) {
      state.seminarInfo.seminarType = seminarType;
    },
    // paid
    SEMINAR_SET_INFO_PAID(state, paid) {
      state.seminarInfo.paid = paid == 'true';
    },
    // courseFee
    SEMINAR_SET_INFO_COURSE_FEE(state, courseFee) {
      state.seminarInfo.courseFee = courseFee;
    },
    SEMINAR_SET_INFO_REMARK(state, remark) {
      state.seminarInfo.remark = remark;
    },
    // hourFrom: '',
    //   minuteFrom: '',
    //   hourTo: '',
    //   minuteTo: '',
    SEMINAR_SET_INFO_HOUR_FROM(state, hourFrom) {
      state.seminarInfo.hourFrom = hourFrom;
    },
    SEMINAR_SET_INFO_MINUTE_FROM(state, minuteFrom) {
      state.seminarInfo.minuteFrom = minuteFrom;
    },
    SEMINAR_SET_INFO_HOUR_TO(state, hourTo) {
      state.seminarInfo.hourTo = hourTo;
    },
    SEMINAR_SET_INFO_MINUTE_TO(state, minuteTo) {
      state.seminarInfo.minuteTo = minuteTo;
    },
    SEMINAR_SET_INFO_INSTRUCTOR_MEMBER_ID1(state, instructorMemberId1) {
      state.seminarInfo.instructorMemberId1 = instructorMemberId1;
    },
    SEMINAR_SET_INFO_INSTRUCTOR_MEMBER_NAME1(state, instructorMemberName1) {
      state.seminarInfo.instructorMemberName1 = instructorMemberName1;
    },
    SEMINAR_SET_INFO_INSTRUCTOR_MEMBER_ID2(state, instructorMemberId2) {
      state.seminarInfo.instructorMemberId2 = instructorMemberId2;
    },
    SEMINAR_SET_INFO_INSTRUCTOR_MEMBER_NAME2(state, instructorMemberName2) {
      state.seminarInfo.instructorMemberName2 = instructorMemberName2;
    },
    SEMINAR_SET_INFO_INSTRUCTOR_MEMBER_ID3(state, instructorMemberId3) {
      state.seminarInfo.instructorMemberId3 = instructorMemberId3;
    },
    SEMINAR_SET_INFO_INSTRUCTOR_MEMBER_NAME3(state, instructorMemberName3) {
      state.seminarInfo.instructorMemberName3 = instructorMemberName3;
    },

    // seminarTypeList
    SEMINAR_SET_TYPE_LIST(state, seminarTypeList) {
      state.seminarTypeList = seminarTypeList;
    },


  }
};



// WEBPACK FOOTER //
// ./src/store/modules/salon.js